import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 90);
    } else {
      scrollToId(id);
    }
  };

  const goTop = () => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      return;
    }
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled
          ? "border-b border-brand-line bg-white/90 backdrop-blur-md"
          : "border-b border-transparent bg-white/70 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-6 lg:px-8">
        <button
          type="button"
          onClick={goTop}
          className="flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2"
          aria-label="IC Identity – till toppen"
          data-testid="header-logo"
        >
          <Logo className="h-8 w-auto md:h-10" />
        </button>

        <nav className="hidden items-center gap-9 md:flex" aria-label="Huvudmeny">
          {NAV.map((n) => (
            <button
              key={n.id}
              type="button"
              onClick={() => go(n.id)}
              className="text-sm font-medium text-brand-ink/80 transition-colors hover:text-brand-blue"
              data-testid={`nav-${n.id}`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <button
          type="button"
          className="-mr-2 p-2 text-brand-ink md:hidden"
          aria-label={open ? "Stäng meny" : "Öppna meny"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-brand-line bg-white md:hidden" data-testid="mobile-menu">
          <nav className="mx-auto flex max-w-6xl flex-col px-6 py-2" aria-label="Mobilmeny">
            {NAV.map((n) => (
              <button
                key={n.id}
                type="button"
                onClick={() => go(n.id)}
                className="border-b border-brand-line py-4 text-left text-base font-medium text-brand-ink"
                data-testid={`mobile-nav-${n.id}`}
              >
                {n.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => go("kontakt")}
              className="btn-primary mt-5 mb-4 w-full"
              data-testid="mobile-cta"
            >
              Börja med ett samtal
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
